import { nameToIdDefault as t, initAction as r } from "@reatom/core";

function e() {
  return (e = Object.assign || function (t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function n(t) {
  return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function o(t, r) {
  return (o = Object.setPrototypeOf || function (t, r) {
    return t.__proto__ = r, t;
  })(t, r);
}

function c() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function i(t, r, e) {
  return (i = c() ? Reflect.construct : function (t, r, e) {
    var n = [null];
    n.push.apply(n, r);
    var c = new (Function.bind.apply(t, n))();
    return e && o(c, e.prototype), c;
  }).apply(null, arguments);
}

function u(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return (u = function u(t) {
    if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, e);
    }

    function e() {
      return i(t, arguments, n(this).constructor);
    }

    return e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), o(e, t);
  })(t);
}

var a = function (t) {
  var r, e;

  function n(r) {
    var e;
    return (e = t.call(this, r) || this).stackTraces = [], Error.captureStackTrace(function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(e), e.constructor), e.getTrace(), e;
  }

  return e = t, (r = n).prototype = Object.create(e.prototype), r.prototype.constructor = r, r.__proto__ = e, n.prototype.getTrace = function () {
    var t = Error.prepareStackTrace;
    Error.prepareStackTrace = function (t, r) {
      return r.map(function (t) {
        return {
          file: t.getFileName(),
          name: t.getFunctionName(),
          line: t.getLineNumber(),
          column: t.getColumnNumber()
        };
      });
    }, this.stackTraces = this.stack || [], Error.prepareStackTrace = t;
  }, n;
}(u(Error)),
    p = {
  useFullPath: !1,
  pathMaxDeep: 3,
  showColumn: !0
};

function f(r) {
  void 0 === r && (r = p);
  var n = e({}, p, {}, r),
      o = n.useFullPath,
      c = n.pathMaxDeep,
      i = n.showColumn;
  return function (r) {
    var e = new a().stackTraces[3];
    if (!e || !e.file) return t(r);
    var n,
        u = Array.isArray(r) ? r[0] : r,
        p = e.file.replace(/\\/g, "/"),
        f = o ? p : p.match("(?:\\/[^\\/]*){1," + c + "}$");
    return ("symbol" == typeof (n = u) ? n.description || n.toString().replace(/Symbol\((.*)\)/, "$1") : n) + " [" + f + ":" + e.line + (i ? ":" + e.column + "]" : "]");
  };
}

function s(t, n) {
  void 0 === n && (n = {});

  var o = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__.connect(n);

  if (o) {
    var c = t.getState();
    return o.init(c), o.subscribe(function (n) {
      "DISPATCH" === n.type && t.dispatch(e({}, r, {
        payload: JSON.parse(n.state)
      }));
    }), t.subscribe(function (t, n) {
      if (t.type !== r.type) {
        var i = Object.keys(n);
        i.push.apply(i, Object.getOwnPropertySymbols(n)), i.length && (c = e({}, c), i.forEach(function (t) {
          "symbol" == typeof t && (t.toString().startsWith("Symbol({") || t.toString().startsWith("Symbol([")) || (c[t.toString()] = n[t]);
        })), o.send(t, c);
      }
    });
  }
}

export { s as connectReduxDevtools, f as genIdFromLine };